import { Component, Input, OnInit } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';

@Component({
  template: `
    <span
      *ngIf="items && items.length > 0"
      [matTooltip]="tooltipText"
      matTooltipClass="esclusione-grandi-acquirenti-tooltip"
      matTooltipPosition="above"
      class="cursor-help"
    >
      {{ firstItemText }}
      <span *ngIf="remainingCount > 0" class="text-blue-400 ml-1">+{{ remainingCount }}</span>
    </span>
    <span *ngIf="!items || items.length === 0">-</span>
  `,
  styles: [
    `
      :host {
        display: inline-block;
      }
      .text-blue-400 {
        color: #60a5fa;
      }
      .ml-1 {
        margin-left: 0.25rem;
      }
      .cursor-help {
        cursor: help;
      }
    `,
  ],
})
export class BigbuyerBrandGoalsRendererComponent implements ViewCell, OnInit {
  @Input() value: any;
  @Input() rowData: any;

  items: any[];

  ngOnInit() {
    this.items = this.value;
  }

  get firstItemText(): string {
    if (!this.items || this.items.length === 0) {
      return '';
    }
    const first = this.items[0];
    return `${first.codiceGA} - ${first.descrizione}`;
  }

  get remainingCount(): number {
    if (!this.items || this.items.length <= 1) {
      return 0;
    }
    return this.items.length - 1;
  }

  get tooltipText(): string {
    if (!this.items || this.items.length === 0) {
      return '';
    }
    return this.items.map((item) => `• ${item.codiceGA} - ${item.descrizione}`).join('\n');
  }
}
